<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Hero Section -->
    <section class="relative overflow-hidden" style="background: linear-gradient(to bottom right, #A3E4DB, #C4E49F);">
      <div class="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>
      <div class="relative container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl py-12 sm:py-16 lg:py-20">
        <div class="grid lg:grid-cols-2 gap-12 items-center">
          <!-- Left Content -->
          <div class="text-gray-800 lg:pr-12">
            <h1 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              <span style="color: #F4D35E;">客製化</span>Line機器人
            </h1>
            <p class="text-base sm:text-lg lg:text-xl mb-2 text-gray-700 leading-relaxed max-w-xl">
              提供客製化的Line機器人解決方案，
            </p>
            <p class="text-base sm:text-lg lg:text-xl mb-8 text-gray-700 leading-relaxed max-w-xl">
              提升校園與家長的溝通效率。
            </p>
          </div>

          <!-- Right Image -->
          <div class="flex justify-center lg:justify-end">
            <div class="relative w-full max-w-md">
              <img src="@/assets/img/pic0.jpg" alt="客製化Line機器人"
                class="rounded-3xl shadow-2xl object-cover w-full h-auto" />
              <!-- Decorative Circles -->
              <div class="absolute -top-4 -right-4 w-20 h-20 bg-yellow-300 rounded-full opacity-20"></div>
              <div class="absolute -bottom-4 -left-4 w-16 h-16 bg-teal-300 rounded-full opacity-20"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Decorative Elements -->
      <div class="absolute top-0 right-0 w-1/3 h-full opacity-10">
        <div class="w-full h-full bg-gradient-to-l from-white to-transparent"></div>
      </div>
    </section>

    <!-- 功能特色區 -->
    <section class="py-8 bg-white">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-800 mb-12 text-center">
          功能特色
        </h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <!-- 功能卡 1 -->
          <div class="flex items-start gap-4">
            <div class="w-10 h-10 bg-[#E9967A] rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-800 mb-2">Logo位置客製化</h3>
              <p class="text-gray-600">把各個幼兒園的Logo導入進到分享介面,可以透過點擊將這官方分享給其他人</p>
            </div>
          </div>

          <!-- 功能卡 2 -->
          <div class="flex items-start gap-4">
            <div class="w-10 h-10 bg-[#A6C48A] rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-800 mb-2">校園活動</h3>
              <p class="text-gray-600">針對每一間不同所 幼兒園 導入各自展示網頁</p>
            </div>
          </div>

          <!-- 功能卡 3 -->
          <div class="flex items-start gap-4">
            <div class="w-10 h-10 bg-[#5FB4BF] rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-800 mb-2">注意事項</h3>
              <p class="text-gray-600">可以將校園需分享事件已注意事項去做放置</p>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- 操作介面導覽 -->
    <section class="py-8 bg-gray-50">
      <div class="p-8 sm:p-12">
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-800 mb-6 text-center">
          介面導覽
        </h2>
        <p class="text-lg text-gray-600 mb-8 text-center">
          點擊下方圖片可放大檢視
        </p>
      </div>
      <div class="mb-16 text-center">
        <img :src="lightboxImages[0]" alt="客製化Line機器人"
          class="rounded-3xl shadow-2xl w-full max-w-xs mx-auto object-cover cursor-zoom-in transition hover:scale-105"
          @click="showImg(0)" />
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-8 -mb-3 bg-white">
      <div class="container mx-auto px-6 text-center">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-4xl font-bold text-gray-800 mb-6">
            立即體驗客製化Line機器人
          </h2>
          <p class="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            專業團隊提供完整的產品諮詢與技術支援，協助您快速部署
          </p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <router-link to="/contactus">
              <button aria-label="聯絡我們瞭解更多"
                  class="text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                  style="background-color: #F4D35E; --tw-bg-opacity: 1;"
                  onmouseover="this.style.backgroundColor='#fce788'"
                  onmouseout="this.style.backgroundColor='#F4D35E'"
                >
                聯絡我們瞭解更多
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- Lightbox -->
    <VueEasyLightbox :visible="lightboxVisible" :imgs="lightboxImages" :index="lightboxIndex" @hide="hideLightbox" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import VueEasyLightbox from 'vue-easy-lightbox'

import img1 from '@/assets/img/pic.jpg'

const lightboxVisible = ref(false)
const lightboxIndex = ref(0)
const lightboxImages = ref([img1])

const showImg = (index) => {
  lightboxIndex.value = index
  lightboxVisible.value = true
}

const hideLightbox = () => {
  lightboxVisible.value = false
}
</script>

<style lang="scss" scoped>
// 修正 z-index 層級問題
.text-gray-800 {
  position: relative;
  z-index: 1;
}

// Hero section 的背景層級
.absolute.inset-0 {
  z-index: 0;
}

// 裝飾元素層級
.absolute.top-0.right-0 {
  z-index: 0;
}

section.bg-white {
  position: relative;
  z-index: 1;
}

// 卡片 hover 效果
.group:hover .w-6.h-6 {
  transform: scale(1.1);
}

// 響應式設計
@media (max-width: 768px) {
  .grid.md\\:grid-cols-2 {
    grid-template-columns: 1fr;
  }

  .grid.md\\:grid-cols-3 {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .text-3xl.sm\\:text-4xl.lg\\:text-6xl {
    font-size: 2rem;
  }

  .text-base.sm\\:text-lg.lg\\:text-xl {
    font-size: 1rem;
  }
}

// 動畫效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeInUp {
  animation: fadeInUp 0.6s ease-out;
}

// 按鈕 hover 效果
button {
  transition: all 0.3s ease;
}

button:hover {
  transform: translateY(-2px);
}

// 響應式按鈕
@media (max-width: 640px) {
  .flex.flex-col.sm\\:flex-row {
    flex-direction: column;
  }

  button {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

// 圖片容器樣式
img {
  transition: transform 0.3s ease;
}

img:hover {
  transform: scale(1.02);
}

// 功能卡片 hover 效果
.flex.items-start.gap-4 {
  transition: all 0.3s ease;
  padding: 1rem;
  border-radius: 1rem;
}

.flex.items-start.gap-4:hover {
  background-color: rgba(59, 130, 246, 0.05);
  transform: translateY(-2px);
}

// 漸層背景
.bg-gradient-to-br.from-sky-50.to-emerald-50 {
  background: linear-gradient(135deg, #f0f9ff 0%, #ecfdf5 100%);
}
</style>